<template>
  <Footer :RedirectUrl="redirectUrl" v-if="!fromwechat" />
</template>
<script>
// import { mapActions, mapGetters } from 'vuex';
// import { Footer } from '@handl-web/vue-pz/Footer';
// import Footer from '@shared-components/Footer.vue';
// import { LOGIN_PAGE, LANDING_PAGE } from '../constants/routes';
import { REDIRECT_URLS, ARTICLES_PAGE } from '../constants';
// import { PORTAL_URLS } from '../constants';

export default {
  name: 'SharedFooter',
  components: {
    // Footer,
  },
  data: () => {
    return {
      redirectUrl: { 
        ...REDIRECT_URLS,
        //ARTICLES_PAGE,
      },
      fromwechat: window.sessionStorage.getItem('fromwechat'),
    };
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
